import { createFileRoute, redirect } from '@tanstack/react-router';

import { BILLING_DEFAULT_PATH } from '&/features/billing/paths';

// SWOOP-430: Billing moved out of Leasing into its own top-level area; the old Leasing › Billing address
// (`/leasing/billing`) now redirects to the Billing area (Invoices).
//
// The trailing `_` on `leasing_` keeps this route OUT of the `/leasing` layout, so its module + `leasing:access`
// gate never runs for this path: a Billing Officer (no `leasing:access`) or a tenant without the Leasing module
// still reaches Billing instead of being bounced by that gate. The target `/billing` has its own `billing:list`
// gate, so no access is widened. A bookmark from the previous SOON item lands on the new area, not a dead page.
export const Route = createFileRoute('/_authenticated/leasing_/billing')({
  beforeLoad: (): void => {
    throw redirect({ to: BILLING_DEFAULT_PATH });
  },
});
